// PageHeader.js
import React from "react"
import { Link } from "react-router-dom"
import styles from "../styles/PageHeader.module.css"

const PageHeader = ({ title, actions }) => {
  return (
    <div className={styles["page-header"]}>
      <h1>{title}</h1>
      {actions && (
        <div className={styles["page-actions"]}>
          {actions.map((action, index) => (
            <Link key={index} to={action.to} className={styles.btn}>
              {action.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default PageHeader
